import React from 'react'
import { Smartphone, Users, TrendingDown } from 'lucide-react'

const Problem = () => {
  const painPoints = [
    {
      icon: Smartphone,
      title: 'Open Bible App, End Up on TikTok',
      description:
        'You start with good intentions, but one notification derails 15 minutes of prayer. Sound familiar? The average person checks their phone 96 times daily—4 times during a typical 10-minute prayer attempt.',
      emoji: '📱💔',
    },
    {
      icon: Users,
      title: 'Solo Prayers Feel Like Shouting Into the Void',
      description:
        '68% of young adults attend church less than monthly. Without accountability, your "I\'ll pray tomorrow" becomes 30 days of spiritual disconnect. You want community, not isolation.',
      emoji: '😔',
    },
    {
      icon: TrendingDown,
      title: 'No Idea If You\'re Actually Growing',
      description:
        'You pray sporadically, feel guilty, start again. Repeat. Without tracking your consistency or measuring progress, spiritual growth feels impossible to quantify or celebrate.',
      emoji: '📉',
    },
  ]

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        {/* Headline */}
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-heading-dark mb-4">
            Your Phone Shouldn't Be the{' '}
            <span className="text-error">Enemy</span> of Your Faith
          </h2>
          <p className="text-lg md:text-xl text-body-gray max-w-3xl mx-auto">
            You're not alone. <span className="font-semibold">79% of young Christians</span> feel phone addiction
            prevents them from consistent prayer.
          </p>
        </div>

        {/* Pain Points Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {painPoints.map((point, index) => {
            const Icon = point.icon
            return (
              <div
                key={index}
                className="card text-center animate-on-scroll"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="text-5xl mb-4">{point.emoji}</div>
                <h3 className="text-xl font-bold text-heading-dark mb-3">{point.title}</h3>
                <p className="text-body-gray leading-relaxed">{point.description}</p>
              </div>
            )
          })}
        </div>

        {/* Infographic */}
        <div className="max-w-4xl mx-auto animate-on-scroll">
          <h3 className="text-2xl font-bold text-center text-heading-dark mb-8">
            The Prayer Distraction Cycle
          </h3>
          <div className="bg-grace-gray rounded-2xl p-8">
            <div className="flex flex-wrap justify-center items-center gap-4">
              {[
                { emoji: '🤔', text: 'Want to pray' },
                { emoji: '📱', text: 'Open phone' },
                { emoji: '🔔', text: 'Notification appears' },
                { emoji: '😰', text: '30 min later on social media' },
                { emoji: '😞', text: 'Guilt sets in' },
                { emoji: '🔁', text: 'Try again tomorrow...' },
              ].map((step, index) => (
                <React.Fragment key={index}>
                  <div className="flex flex-col items-center text-center">
                    <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center text-3xl mb-2 shadow-md">
                      {step.emoji}
                    </div>
                    <p className="text-sm font-medium text-body-gray max-w-[100px]">{step.text}</p>
                  </div>
                  {index < 5 && (
                    <div className="text-prayer-blue text-2xl hidden sm:block">→</div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Problem
